var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
export var LockIcon = function (props) { return (React.createElement(SvgIcon, __assign({}, props),
    React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12 5C12 2.23858 9.76142 0 7 0C4.23858 0 2 2.23858 2 5V7C0.89543 7 0 7.89543 0 9V17C0 18.1046 0.89543 19 2 19H12C13.1046 19 14 18.1046 14 17V9C14 7.89543 13.1046 7 12 7V5ZM11 7V5C11 2.79086 9.20914 1 7 1C4.79086 1 3 2.79086 3 5V7H11ZM1 9C1 8.44771 1.44772 8 2 8H12C12.5523 8 13 8.44771 13 9V17C13 17.5523 12.5523 18 12 18H2C1.44772 18 1 17.5523 1 17V9ZM7.5 11.8662C7.7989 11.6933 8 11.3701 8 11C8 10.4477 7.55228 10 7 10C6.44772 10 6 10.4477 6 11C6 11.3701 6.2011 11.6933 6.5 11.8662V13.5C6.5 13.7761 6.72386 14 7 14C7.27614 14 7.5 13.7761 7.5 13.5V11.8662Z" }))); };
//# sourceMappingURL=LockIcon.js.map